module.exports = __webpack_public_path__ + "static/media/la-cover-video.331c9961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-cover-video.jpg
// module id = 767
// module chunks = 1